import { createAction } from '@reduxjs/toolkit';
import {
  START_SEARCH,
  STOP_SEARCH,
  SET_SEARCHER_CAROUSEL_DATE,
  UPDATE_REQUEST_ID,
  SET_SEARCHER_DATE,
  SET_START_DATE,
  SET_KIDS,
  SET_DEPARTURE,
  TOGGLE_INSTANT_CONFIRM,
  SEARCH_PRICE_FOR_DATE,
  SEARCH_WITH_DEFAULT_DEPARTURE,
  SET_FILTERS,
  CLEAR_OPERATORS_FILTER,
  CLEAR_SEARCHER_FILTERS,
  SET_SEARCHER_FETCHING,
  SET_NEXT_PAGE,
  SET_HOTELS_COUNT,
  REQUEST_NEXT_PAGE,
  SET_CONTINUE_FIRST_SEARCH,
  SET_SEARCHER_PARAMS,
  UPDATE_SEARCHER_PARAMS,
  SET_DEFAULT_FILTERS,
  OPEN_FILTERS_LIST,
  SET_EMPTY_SEARCHER,
  FILTERS_SUBMIT_CLICKED,
} from '../constants/searcher';

export const startSearchAction = () => ({
  type: START_SEARCH,
});

export const stopSearchAction = () => ({
  type: STOP_SEARCH,
});

/**
 * @typedef CarouselDatePayload
 * @property {string} date
 * @property {boolean} loadData
 * @param {CarouselDatePayload} payload
 */
export const setSearcherCarouselDateAction = (payload) => ({
  type: SET_SEARCHER_CAROUSEL_DATE,
  payload,
});

export const updateRequestIdAction = (payload) => ({
  type: UPDATE_REQUEST_ID,
  payload,
});

export const setStartDateAction = (payload) => ({
  type: SET_START_DATE,
  payload,
});

export const setSearcherDateAction = (payload) => ({
  type: SET_SEARCHER_DATE,
  payload,
});

export const setKidsAction = (payload) => ({
  type: SET_KIDS,
  payload,
});

export const setDepartureAction = (payload) => ({
  type: SET_DEPARTURE,
  payload,
});

export const searchWithDefaultDepartureAction = () => ({
  type: SEARCH_WITH_DEFAULT_DEPARTURE,
});

export const toggleInstantConfirmAction = () => ({
  type: TOGGLE_INSTANT_CONFIRM,
});

export const searchPriceForDateAction = createAction<string>(
  SEARCH_PRICE_FOR_DATE,
);

export const setSearcherFiltersAction = (payload) => ({
  type: SET_FILTERS,
  payload,
});

export const setSearcherDefaultFiltersAction =
  createAction<boolean>(SET_DEFAULT_FILTERS);

export const clearSearcherOperatorsFilterAction = () => ({
  type: CLEAR_OPERATORS_FILTER,
});

export const clearSearcherFiltersAction = () => ({
  type: CLEAR_SEARCHER_FILTERS,
});
export const setSearcherFetchingAction = (payload) => ({
  type: SET_SEARCHER_FETCHING,
  payload,
});

export const setNextPageAction = () => ({
  type: SET_NEXT_PAGE,
});

export const requestNextPageAction = () => ({
  type: REQUEST_NEXT_PAGE,
});

export const setHotelsCountAction = (payload) => ({
  type: SET_HOTELS_COUNT,
  payload,
});

export const setContinueFirstSearchAction = (payload) => ({
  type: SET_CONTINUE_FIRST_SEARCH,
  payload,
});

export const setSearcherParamsAction = (payload) => ({
  type: SET_SEARCHER_PARAMS,
  payload,
});

export const updateSearcherParamsAction = (payload) => ({
  type: UPDATE_SEARCHER_PARAMS,
  payload,
});

export const openFiltersListAction = createAction<boolean>(OPEN_FILTERS_LIST);

export const setEmptySearcherAction = createAction(SET_EMPTY_SEARCHER);

export const submitFiltersAction = createAction(FILTERS_SUBMIT_CLICKED);
